export const authConstants = {
  LOGIN_LOAD: 'LOGIN_LOAD',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGOUT: 'LOGOUT',
  ACCESS_CODE_REQUEST: 'ACCESS_CODE_REQUEST',
  ACCESS_CODE_REQUEST_SUCCESS: 'ACCESS_CODE_REQUEST_SUCCESS',
  ACCESS_CODE_REQUEST_ERROR: 'ACCESS_CODE_REQUEST_ERROR',
  CONSULTANT_LOGIN_SUCCESS: 'CONSULTANT_LOGIN_SUCCESS',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  UPDATE_ERROR: 'UPDATE_ERROR',
  UPDATE_TOKEN: 'UPDATE_TOKEN',
}

export const alertConstants = {
  ALERT_SUCCESS: 'ALERT_SUCCESS',
  ALERT_ERROR: 'ALERT_ERROR',
  ALERT_CLEAR: 'ALERT_CLEAR',
}

export const userConstants = {
  FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  FETCH_USER_ERROR: 'FETCH_USER_ERROR',
}

export const consultantConstants = {
  FETCH_CONSULTANT_SUCCESS: 'FETCH_CONSULTANT_SUCCESS',
}

export const opportunityConstants = {
  CREATE_OPPORTUNITY_REQUEST: 'CREATE_OPPORTUNITY_REQUEST',
  CREATE_OPPORTUNITY_SUCCESS: 'CREATE_OPPORTUNITY_SUCCESS',
  CREATE_OPPORTUNITY_ERROR: 'CREATE_OPPORTUNITY_ERROR',

  RECEIVE_OPPORTUNITY_ID: 'RECEIVE_OPPORTUNITY_ID',
  FETCH_OPPORTUNITY_REQUEST: 'FETCH_OPPORTUNITY_REQUEST',
  FETCH_OPPORTUNITY_SUCCESS: 'FETCH_OPPORTUNITY_SUCCESS',
  FETCH_OPPORTUNITY_ERROR: 'FETCH_OPPORTUNITY_ERROR',

  FETCH_OPPORTUNITY_INFO_REQUEST: 'FETCH_OPPORTUNITY_INFO_REQUEST',
  FETCH_OPPORTUNITY_INFO_SUCCESS: 'FETCH_OPPORTUNITY_INFO_SUCCESS',
  FETCH_OPPORTUNITY_INFO_ERROR: 'FETCH_OPPORTUNITY_INFO_ERROR',
}

export const estimateConstants = {
  FETCH_INDIVIDUAL_ESTIMATE_REQUEST: 'FETCH_INDIVIDUAL_ESTIMATE_REQUEST',
  FETCH_INDIVIDUAL_ESTIMATE_SUCCESS: 'FETCH_INDIVIDUAL_ESTIMATE_SUCCESS',
  FETCH_INDIVIDUAL_ESTIMATE_ERROR: 'FETCH_INDIVIDUAL_ESTIMATE_ERROR',
  //for compare page

  FETCH_ESTIMATES_REQUEST: 'FETCH_ESTIMATES_REQUEST',
  FETCH_ESTIMATES_SUCCESS: 'FETCH_ESTIMATES_SUCCESS',
  FETCH_ESTIMATES_ERROR: 'FETCH_ESTIMATES_ERROR',
}

export const contactUsConstants = {
  UPDATE_MODE_OF_CONTACT_TO_PHONE: 'UPDATE_MODE_OF_CONTACT_TO_PHONE',
  UPDATE_MODE_OF_CONTACT_TO_EMAIL: 'UPDATE_MODE_OF_CONTACT_TO_EMAIL',
  UNKNOWN_MODE_OF_CONTACT: 'UNKNOWN_MODE_OF_CONTACT',
  SUCCESS_CONTACT_CONSULTANT_SUBMISSION:
    'SUCCESS_CONTACT_CONSULTANT_SUBMISSION',
  FAILURE_CONTACT_CONSULTANT_SUBMISSION:
    'FAILURE_CONTACT_CONSULTANT_SUBMISSION',
  INPROGRESS_CONTACT_CONSULTANT_SUBMISSION:
    'INPROGRESS_CONTACT_CONSULTANT_SUBMISSION',
  RESET_STATUS_CONTACT_CONSULTANT: 'RESET_STATUS_CONTACT_CONSULTANT',
}

export const applicationRoles = {
  USER_WITH_ESTIMATES: 'USER_WITH_ESTIMATES',
  USER_ACCEPTED_ESTIMATE: 'USER_ACCEPTED_ESTIMATE',
  USER_WITH_PROPOSAL_SETUP: 'USER_WITH_PROPOSAL_SETUP',
  USER_WITH_PROPOSAL_ACCEPTED: 'USER_WITH_PROPOSAL_ACCEPTED',
  CONSULTANT: 'CONSULTANT',
  CUSTOMER: 'CUSTOMER',
}

export const proposalAuthorisedConstants = {
  PROPOSAL_AUTHORISED: 'PROPOSAL_AUTHORISED',
  PROPOSAL_NOT_AUTHORISED: 'PROPOSAL_NOT_AUTHORISED',
  PROPOSAL_ID_RECEIVED: 'PROPOSAL_ID_RECEIVED',
}

export const emailConstants = {
  EMAIL_PROPOSAL_VIEW: 'EMAIL_PROPOSAL_VIEW',
}

export const captchaConstants = {
  VALIDATE_CAPTCHA_SUCCESS: 'VALIDATE_CAPTCHA_SUCCESS',
  VALIDATE_CAPTCHA_FAILURE: 'VALIDATE_CAPTCHA_FAILURE',
  VALIDATE_CAPTCHA_INPROGRESS: 'VALIDATE_CAPTCHA_INPROGRESS',
}

export const proposalOnAcceptanceConstants = {
  PROPOSAL_ACCEPTANCE_SUCCESS: 'PROCEED_ESTIMATE_SUCCESS',
  PROPOSAL_ACCEPTANCE_FAILED: 'PROCEED_ESTIMATE_FAILED',
  PROPOSAL_ACCEPTANCE_SUBMITTING: 'PROCEED_ESTIMATE_SUBMITTING',
  CANCEL_PROPOSAL_ACCEPTANCE_SUCCESS: 'CANCEL_PROCEED_ESTIMATE_SUCCESS',
  CANCEL_PROPOSAL_ACCEPTANCE_FAILED: 'CANCEL_PROCEED_ESTIMATE_FAILED',
  CANCEL_PROPOSAL_ACCEPTANCE_SUBMITTING: 'CANCEL_PROCEED_ESTIMATE_SUBMITTING',
  RESET_PROPOSAL_ACCEPTANCE_ERROR_MESSAGE:
    'RESET_PROCEED_ESTIMATE_ERROR_MESSAGE',
}

export const proceedOnEstimateConstants = {
  PROCEED_ESTIMATE_SUCCESS: 'PROCEED_ESTIMATE_SUCCESS',
  PROCEED_ESTIMATE_FAILED: 'PROCEED_ESTIMATE_FAILED',
  PROCEED_ESTIMATE_SUBMITTING: 'PROCEED_ESTIMATE_SUBMITTING',
  CANCEL_PROCEED_ESTIMATE_SUCCESS: 'CANCEL_PROCEED_ESTIMATE_SUCCESS',
  CANCEL_PROCEED_ESTIMATE_FAILED: 'CANCEL_PROCEED_ESTIMATE_FAILED',
  CANCEL_PROCEED_ESTIMATE_SUBMITTING: 'CANCEL_PROCEED_ESTIMATE_SUBMITTING',
  RESET_PROCEED_ESTIMATE_ERROR_MESSAGE: 'RESET_PROCEED_ESTIMATE_ERROR_MESSAGE',
}

export const httpVerbConstants = {
  HTTP_GET: 'GET',
  HTTP_POST: 'POST',
  HTTP_PUT: 'PUT',
}

export const downloadPdfConstants = {
  STARTED_DOWNLOAD: 'STARTED_DOWNLOAD',
  FINISHED_DOWNLOAD: 'FINISHED_DOWNLOAD',
}

export const nextstepsConstants = {
  FETCH_NEXTSTEPS_REQUEST: 'FETCH_NEXTSTEPS_REQUEST',
  FETCH_NEXTSTEPS_SUCCESS: 'FETCH_NEXTSTEPS_SUCCESS',
}

export const browserConstants = {
  SET_BROWSER: 'SET_BROWSER',
  DISPLAY_NOTIFICATION: 'DISPLAY_NOTIFICATION',
}
export const spartaCountConstants = {
  FETCH_SPARTACOUNT_REQUEST: 'FETCH_SPARTACOUNT_REQUEST',
  FETCH_SPARTACOUNT_SUCCESS: 'FETCH_SPARTACOUNT_SUCCESS',
}

export const finAppStatusConstants = {
  FETCH_FINAPPSTATUS_REQUEST: 'FETCH_FINAPPSTATUS_REQUEST',
  FETCH_FINAPPSTATUS_SUCCESS: 'FETCH_FINAPPSTATUS_SUCCESS',
}

export const settlementConstants = {
  FETCH_SETTLEMENT_REQUEST: 'FETCH_SETTLEMENT_REQUEST',
  FETCH_SETTLEMENT_SUCCESS: 'FETCH_SETTLEMENT_SUCCESS',
}
